<template>

  <header class="flex flex-col items-center justify-center h-screen bg-cover bg-center bg-no-repeat" style="background-color: #BC0A19;">
    <div class="flex flex-col items-center max-h-full gap-7">
      <img class="w-full max-h-full object-contain" src="@/assets/logo.png" style="max-height: 80%;" />
      <button @click="scrollToForm" class="px-4 py-2 bg-transparent text-white font-semibold hover:bg-white hover:text-red-600 border rounded">
        <i class="pi pi-check mr-2"></i>ACREDITARME
      </button>
      <img class="w-full object-contain" src="@/assets/sponsors.png" style="max-height: 40%;" />

    </div>
  </header>


</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'HeaderSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>